import { getConfig } from "./runtimeConfig";

export const isShadow =
  getConfig("REACT_APP_ENVIRONMENT") === "shadow";

export const isDevelopment =
  getConfig("REACT_APP_ENVIRONMENT") !== "production" && !isShadow;
